import { DetailedCountryFragment } from 'src/legacy_graphql'

export const isCountryAffiliaetEligible = (
  affiliateCountries: DetailedCountryFragment[],
  currentCountry: string,
): boolean => {
  const countries = [...affiliateCountries.map(country => country.postalName)]

  return countries.includes(currentCountry)
}
